const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:3001"
    : "https://gcchf-server-ljnck.ondigitalocean.app";
export default BASE_URL;
